export default "__VITE_ASSET__B0H1pvfA__"